/**
 * Force a real download of a file at `url` instead of opening it in the
 * browser. The native `<a download>` attribute is silently ignored when the
 * URL is cross-origin (e.g. IPFS gateway), so we have to fetch the bytes
 * ourselves and trigger the download via an object URL.
 *
 * Falls back to opening the URL in a new tab if the fetch fails.
 */
export async function downloadFile(url: string, filename: string): Promise<void> {
  try {
    const res = await fetch(url, { mode: 'cors' });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const blob = await res.blob();
    const objectUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = objectUrl;
    a.download = filename;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
  } catch {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}

/** Sanitize a string for use as a filename. */
export function safeFilename(name: string, ext = 'png'): string {
  const stem = name.replace(/[^a-zA-Z0-9._-]+/g, '_').slice(0, 80) || 'badge';
  return `${stem}.${ext}`;
}
